import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { request } from '@utils';
import { showErrorToast } from '@hooks/showErrorToast';

interface TransitProps {
  id: string;
  data: any;
}

export const useSendNonArrivalInfo = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, data }: TransitProps) => {
      return request({
        path: `transits/send-non-arrival-info`,
        method: 'POST',
        authenticate: true,
        dataObject: { transitId: id, data },
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      queryClient.invalidateQueries({ queryKey: ['transit', variables.id] });
      toast.success(`Non-arrival info was sent!`);
    },
    onError: (error) => {
      showErrorToast(error, `Error sending the non-arrival info!`);
    },
  });
};
